export const StatePanelStates = Object.freeze({
    Loading: 'loading',
    Error: 'error',
    Success: 'success'
});

export type StatePanelState = (typeof StatePanelStates)[keyof typeof StatePanelStates];
